module.exports = __webpack_public_path__ + "static/media/illustrator.17e4c487.png";